import React from "react";
import elephantAndDog from "../assets/elephentanddog2.png";

const Utilities = () => {
  return (
    <div
      id="utilities"
      className="bg-warm-yellow px-4 md:px-16 pt-20  text-black"
    >
      <div className="text-3xl md:text-6xl font-bold text-center pb-16">
      <span className="elephonkHeading">Elephonk</span> Utilities
      </div>
      <div className="flex flex-col md:grid grid-cols-3 gap-8 md:gap-4">
        <div className="rounded-lg md:rounded-full p-8 w-full md:w-fit text-center  border-2 border-black">
          <h1 className="font-bold text-lg md:text-2xl">ELEPHONK Swap</h1>
          <div className="h-0.5 w-[20%] mx-auto my-4 bg-orange"></div>
          <p className="text-sm md:text-xl">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Explicabo,
            reprehenderit!
          </p>
        </div>
        <div className="rounded-lg md:rounded-full p-8 w-full md:w-fit text-center  border-2 border-black">
          <h1 className="font-bold text-lg md:text-2xl">ELEPHONK Raffle</h1>
          <div className="h-0.5 w-[20%] mx-auto my-4 bg-orange"></div>
          <p className="text-sm md:text-xl">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Explicabo,
            reprehenderit!
          </p>
        </div>
        <div className="rounded-lg md:rounded-full p-8 w-full md:w-fit text-center  border-2 border-black">
          <h1 className="font-bold text-lg md:text-2xl">Voting</h1>
          <div className="h-0.5 w-[20%] mx-auto my-4 bg-orange"></div>
          <p className="text-sm md:text-xl">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Explicabo,
            reprehenderit!
          </p>
        </div>
        <div className="rounded-lg md:rounded-full p-8 w-full md:w-fit text-center  border-2 border-black">
          <h1 className="font-bold text-lg md:text-2xl">Staking Pool</h1>
          <div className="h-0.5 w-[20%] mx-auto my-4 bg-orange"></div>
          <p className="text-sm md:text-xl">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Explicabo,
            reprehenderit!
          </p>
        </div>
        <div className="rounded-lg md:rounded-full p-8 w-full md:w-fit text-center  border-2 border-black">
          <h1 className="font-bold text-lg md:text-2xl">ELEPHONK Bridge</h1>
          <div className="h-0.5 w-[20%] mx-auto my-4 bg-orange"></div>
          <p className="text-sm md:text-xl">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Explicabo,
            reprehenderit!
          </p>
        </div>
        <div className="rounded-lg md:rounded-full p-8 w-full md:w-fit text-center  border-2 border-black">
          <h1 className="font-bold text-lg md:text-2xl">Mini Games</h1>
          <div className="h-0.5 w-[20%] mx-auto my-4 bg-orange"></div>
          <p className="text-sm md:text-xl">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Explicabo,
            reprehenderit!
          </p>
        </div>
      </div>
      <div className="pt-20 text-center">
        <img src={elephantAndDog} alt="" className="w-3/4 md:w-1/3  mx-auto" />
        <div className="-translate-y-8 md:-translate-y-16">
          <h1 className="text-4xl md:text-7xl font-bold elephonkHeading">ELEPHONK</h1>
          <h2 className="text-xl md:text-2xl font-semibold py-2">
            More Than a Cryptocurrency
          </h2 >
          <p className="md:w-1/2 mx-auto text-sm md:text-xl">
            ELEPHONK believes in the potential of Solana to change the world for
            the better. It's not just a memecoin; it's a movement dedicated to
            making Solana more inclusive and welcoming. ELEPHONK aims to
            simplify the crypto experience, ensuring it is accessible to
            everyone.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Utilities;
